import {xhr} from "../../../client/helper";


const adElements = document.querySelectorAll('.app-ad');
const TIMER = {};
const HAS_VIEW = {};


Array.from(adElements).forEach(element => {
    initAd(element);
});


function initAd(element) {
    const path = element.getAttribute('data-path');
    const scrollHandler = event => {
        if (!HAS_VIEW[path]) {
            checkAndPush(path);
        } else {
            window.removeEventListener('scroll', scrollHandler);
        }
    };

    if (!path) {
        return;
    }

    if (isInViewport(element)) {
        checkAndPush(path);
    }

    window.addEventListener('scroll', scrollHandler);
}

function checkAndPush(path) {
    clearTimeout(TIMER[path])
    TIMER[path] = setTimeout(() => {
        xhr('POST', `/s/${path}/`).then(response => {
            HAS_VIEW[path] = true;
        }).catch(err => {
            console.log(err)
        })
    }, 2000);
}


function isInViewport (elem) {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
